import endpoints from '../ajax/endpoints';
import parseResponse from './parse-response';
import inLoopNonParallelFactory from './base-service/in-loop-non-parallel-factory';
import EndPointProtection from './endpoint-protection-service';

export default function (app) {
	app.service('EndPointProtection', EndPointProtection);
	app.factory('BaseService', ['ajax', '$q', 'ajaxNotification', 'EndPointProtection',
		function (ajax, $q, ajaxNotification, EndPointProtection) {

		function createPromise(endpoint, params) {
			var defer = $q.defer();
			var returnProperty = endpoints[endpoint].returnProperty || null;


			if(EndPointProtection.isEndPointOpenForMoreRequest(endpoint)) {
				ajax.promisedRequest(endpoint, params)
					.then(function (response) {
							// Az endpoint specifikus kulcsokat homogenizáljuk
							parseResponse(response, returnProperty);
							globalPopupHandler(endpoint, 'success');
							defer.resolve(response);
					})
					.catch(function (error) {
						globalPopupHandler(endpoint, 'error');
						// Tovább dobjuk a hibát, hogy a controllerben is lehessen egyeni hanflert írni rá
						defer.reject(error);
					});

			} else {
				defer.reject({status: 429});
			}
			return defer.promise;
		}

		function createInLoop(endpoint, params) {
			var defer = $q.defer();
			var returnProperty = endpoints[endpoint].returnProperty || null;

			if(EndPointProtection.isEndPointOpenForMoreRequest(endpoint)) {
				ajax.inLoopPromises(endpoint, params)
					.then(function () {
						var responses = arguments[0];

						for (var i = 0; i < responses.length; i++) {
							// Az endpoint specifikus kulcsokat homogenizáljuk
							parseResponse(responses[i], returnProperty);
						}
						globalPopupHandler(endpoint, 'success');
						defer.resolve(responses);
					})
					.catch(function (error) {
						globalPopupHandler(endpoint, 'error');
						defer.reject(error);

					});
				return defer.promise;
			} else {
				defer.reject('Endpoint limit reached');
			}

		}

		function globalPopupHandler(endpoint, type) {
			var endpointOptions = endpoints[endpoint];

			if (endpointOptions && endpointOptions.popup && !endpointOptions.popup.handleInController) {
				ajaxNotification.setResponse(endpoint, type);
			}
		}

		function createInLoopNonParallel(endpoint, params) {
			var inLoopNonParallel = inLoopNonParallelFactory($q, createPromise);
			return inLoopNonParallel(endpoint, params);
		}

		function secondDatepickerOpener(dateTo) {
			if (!dateTo) {
				return 'true';
			}
			return 'false';
		}

		return {
			createPromise: createPromise,
			createInLoop: createInLoop,
			createInLoopNonParallel: createInLoopNonParallel,
			secondDatepickerOpener: secondDatepickerOpener
		};
	}]);
};
